module.exports = new __parcel__URL__("star-wars-episode-i-the-phantom-menace.08a3a2fb.jpg").toString();